import React, { createContext, useContext, useEffect, useState } from 'react';

const LanguageContext = createContext();

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'es';
  }

  const storedLanguage = window.localStorage.getItem('site_language');
  if (storedLanguage === 'es' || storedLanguage === 'en') {
    return storedLanguage;
  }

  const preferredLanguages = [
    ...(Array.isArray(window.navigator.languages) ? window.navigator.languages : []),
    window.navigator.language,
    window.navigator.userLanguage,
  ].filter(Boolean);

  const prefersEnglish = preferredLanguages.some((lang) =>
    String(lang).toLowerCase().startsWith('en')
  );

  if (prefersEnglish) {
    return 'en';
  }

  // Default to Spanish when no explicit browser preference is detected.
  return 'es';
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('site_language', language);
    }
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
